import React, { useEffect, useState } from 'react';
import './index.scss';

interface PartnerBannerCarouselProps {
  images: string[];
  intervalMs?: number;
}

const PartnerBannerCarousel = ({ images, intervalMs = 4000 }: PartnerBannerCarouselProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (images.length < 2) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [images.length, intervalMs]);

  if (!images.length) return null;

  return (
    <div className="partner-banner-carousel">
      <img className="partner-banner-carousel-img" src={images[index]} alt="" />
      {images.length > 1 && (
        <div className="partner-banner-carousel-dots">
          {images.map((src, i) => (
            <button
              key={src + i}
              type="button"
              aria-label={`Slide ${i + 1}`}
              className={`partner-banner-carousel-dot${i === index ? ' partner-banner-carousel-dot--active' : ''}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PartnerBannerCarousel;
